/**
 * Grace in LA — Size Advisor
 * File: assets/size-advisor.js
 * v2.2 — Half height steps, brand-first Step 4 (jeans size chips)
 */

(function () {
  'use strict';

  const TOTAL_STEPS = 4;
  const STORAGE_KEY = 'gil_size_profile';

  // Brand-specific size offsets relative to Grace in LA sizing
  const BRAND_OFFSETS = {
    'american-eagle':  0,
    'levis':           1,
    'abercrombie':     0,
    'wrangler':        1,
    'lee':             1,
    'old-navy':       -1,
    'gap':             0,
    'other':           0
  };

  // Typical size ranges shown as chips per brand
  // Each entry maps to a display label and the waist-inch equivalent
  const BRAND_SIZES = {
    'american-eagle': [
      { label: '00', waist: 24 }, { label: '0',  waist: 25 }, { label: '2',  waist: 26 },
      { label: '4',  waist: 27 }, { label: '6',  waist: 28 }, { label: '8',  waist: 29 },
      { label: '10', waist: 30 }, { label: '12', waist: 31 }, { label: '14', waist: 32 }
    ],
    'abercrombie': [
      { label: '23', waist: 23 }, { label: '24', waist: 24 }, { label: '25', waist: 25 },
      { label: '26', waist: 26 }, { label: '27', waist: 27 }, { label: '28', waist: 28 },
      { label: '29', waist: 29 }, { label: '30', waist: 30 }, { label: '32', waist: 32 }
    ],
    'old-navy': [
      { label: '0',  waist: 25 }, { label: '2',  waist: 26 }, { label: '4',  waist: 27 },
      { label: '6',  waist: 28 }, { label: '8',  waist: 29 }, { label: '10', waist: 30 },
      { label: '12', waist: 31 }, { label: '14', waist: 32 }, { label: '16', waist: 33 }
    ],
    // Brands that use waist-inch sizing natively get numeric chips
    'levis':    null,
    'wrangler': null,
    'lee':      null,
    'gap':      null,
    'other':    null
  };

  // Default chips shown when no brand is selected — numerical clothing sizes (not waist inches)
  const NUMERIC_SIZE_CHIPS = [
    { label: '0',  waist: 25 }, { label: '2',  waist: 26 }, { label: '4',  waist: 27 },
    { label: '6',  waist: 28 }, { label: '8',  waist: 29 }, { label: '10', waist: 30 },
    { label: '12', waist: 31 }, { label: '14', waist: 32 }, { label: '16', waist: 33 }
  ];

  let state = {
    height_cm:   163,
    weight_kg:   60,
    height_unit: 'cm',
    weight_unit: 'kg',
    fit:         null,
    brandsize:   null,   // waist-inch integer as string, or 'not-sure'
    brandbrand:  null,
    usedChips:   false,  // Fix 3: track whether user picked a chip (higher trust) or typed manually
    result:      null
  };

  let currentStep    = 1;
  let customerLogged = false;
  let customerId     = '';

  const $       = id => document.getElementById(id);
  const modal   = () => $('size-advisor-modal');
  const fill    = () => $('sa-progress-fill');
  const label   = () => $('sa-progress-label');
  const btnNext = () => $('sa-btn-next');
  const btnBack = () => $('sa-btn-back');
  const footer  = () => $('sa-footer');

  /* ══════════════════════════════════════════════════
     ACCOUNT HELPERS
     ══════════════════════════════════════════════════ */

  function detectCustomer() {
    var m = modal();
    if (!m) return;
    customerId     = m.dataset.customerId || '';
    customerLogged = !!(customerId && customerId !== '' && customerId !== 'false');
  }

  function saveProfile(profileData) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(
        Object.assign({}, profileData, { ts: Date.now(), customerId: customerId })
      ));
    } catch (e) {}

    var cfg = window.SizeAdvisorConfig || {};
    if (customerLogged && cfg.saveEndpoint) {
      fetch(cfg.saveEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          customer_id: customerId,
          namespace:   'size_advisor',
          key:         'profile',
          type:        'json',
          value:       JSON.stringify(profileData)
        })
      })
      .then(function (res) { if (res.ok) showAccountSaved(); })
      .catch(function () {});
    } else if (customerLogged) {
      showAccountSaved();
    }
  }

  function loadProfile(callback) {
    var cfg = window.SizeAdvisorConfig || {};
    if (customerLogged && cfg.loadEndpoint) {
      fetch(cfg.loadEndpoint + '?customer_id=' + encodeURIComponent(customerId), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && data.value) {
          try {
            var parsed = typeof data.value === 'string' ? JSON.parse(data.value) : data.value;
            callback(parsed); return;
          } catch (e) {}
        }
        callback(localProfile());
      })
      .catch(function () { callback(localProfile()); });
    } else {
      callback(localProfile());
    }
  }

  function localProfile() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
    catch (e) { return null; }
  }

  function showAccountSaved() {
    var el = $('sa-account-saved');
    if (el) el.removeAttribute('hidden');
  }

  /* ══════════════════════════════════════════════════
     OPEN / CLOSE
     ══════════════════════════════════════════════════ */

  function openModal() {
    var m = modal();
    if (!m) return;
    detectCustomer();
    m.removeAttribute('hidden');
    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    resetAdvisor();
    loadProfile(function (saved) {
      if (saved && saved.waist) showSavedNotice(saved);
    });
    setTimeout(function () {
      var f = m.querySelector('button,[tabindex]');
      if (f) f.focus();
    }, 350);
  }

  function closeModal() {
    var m = modal();
    if (!m) return;
    m.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!m.classList.contains('is-open')) m.setAttribute('hidden', '');
    }, 220);
  }

  function showSavedNotice(saved) {
    var notice = $('sa-saved-notice');
    var text   = $('sa-saved-notice-text');
    if (!notice) return;
    if (text) {
      var lbl = 'Size ' + saved.waist;
      if (saved.inseam) lbl += ' / ' + saved.inseam + '"';
      text.innerHTML = customerLogged
        ? 'Welcome back! Your saved size is <strong>' + lbl + '</strong>.'
        : 'We found your last size: <strong>' + lbl + '</strong>. Retake to update.';
    }
    notice.removeAttribute('hidden');
  }

  function resetAdvisor() {
    state = {
      height_cm: 163, weight_kg: 60,
      height_unit: 'cm', weight_unit: 'kg',
      fit: null, brandsize: null, brandbrand: null, result: null
    };
    document.querySelectorAll('.sa-option-card.is-selected, .sa-chip.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-checked', 'false');
    });
    var bsi = $('sa-brandsize-input');  if (bsi) bsi.value = '';
    var bdd = $('sa-brand-dropdown');   if (bdd) bdd.value = '';
    var bb  = $('sa-brandsize-block');  if (bb)  bb.removeAttribute('hidden'); // always visible — default numeric chips shown
    state.usedChips = false;
    buildSizeChips(''); // show default numeric chips on reset
    var hs  = $('sa-height-slider');    if (hs)  { hs.value = 163; updateSliderGradient(hs); }
    var ws  = $('sa-weight-slider');    if (ws)  { ws.value = 60;  updateSliderGradient(ws); }
    safeSetText('sa-height-display', '163');
    safeSetText('sa-height-unit', 'cm');
    safeSetText('sa-weight-display', '60');
    safeSetText('sa-weight-unit', 'kg');
    toggleClass('sa-h-cm', 'is-active', true);
    toggleClass('sa-h-in', 'is-active', false);
    toggleClass('sa-w-kg', 'is-active', true);
    toggleClass('sa-w-lbs', 'is-active', false);
    var acs = $('sa-account-saved'); if (acs) acs.setAttribute('hidden', '');
    var sn  = $('sa-saved-notice');  if (sn)  sn.setAttribute('hidden', '');
    goToStep(1);
  }

  /* ══════════════════════════════════════════════════
     STEP NAVIGATION
     ══════════════════════════════════════════════════ */

  function goToStep(n) {
    for (var i = 1; i <= 6; i++) {
      var el = $('sa-step-' + i);
      if (el) el.setAttribute('hidden', '');
    }
    var target = $('sa-step-' + n);
    if (target) target.removeAttribute('hidden');
    currentStep = n;
    updateProgress(n);
    updateFooter(n);
    var body = $('sa-body');
    if (body) body.scrollTop = 0;
  }

  function updateProgress(n) {
    var f = fill(), l = label();
    if (!f || !l) return;
    if (n <= TOTAL_STEPS) {
      f.style.width = Math.round(((n - 1) / TOTAL_STEPS) * 100) + '%';
      l.textContent = 'Step ' + n + ' of ' + TOTAL_STEPS;
    } else if (n === 5) {
      f.style.width = '92%';
      l.textContent = 'Calculating\u2026';
    } else {
      f.style.width = '100%';
      l.textContent = 'Done!';
    }
  }

  function updateFooter(n) {
    var f = footer(), bn = btnNext(), bb = btnBack();
    if (!f || !bn) return;
    if (n === 5) { f.style.display = 'none'; return; }
    f.style.display = 'flex';
    if (bb) {
      if (n > 1 && n !== 5) bb.removeAttribute('hidden');
      else bb.setAttribute('hidden', '');
    }
    if (n === 6) {
      bn.innerHTML = '\u2756 Got It \u2014 Apply My Size \u203a';
      bn.classList.add('sa-btn-next--apply');
      if (bb) bb.setAttribute('hidden', '');
    } else {
      bn.innerHTML = 'Continue <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 3 11 8 6 13"/></svg>';
      bn.classList.remove('sa-btn-next--apply');
    }
    bn.disabled = !canProceed(n);
  }

  function canProceed(n) {
    if (n === 1) return true;
    if (n === 2) return true;
    if (n === 3) return !!state.fit;
    if (n === 4) {
      if (state.brandsize === 'not-sure') return true;
      // Accept chip selection OR manual waist input
      var bsi = $('sa-brandsize-input');
      var val = bsi ? bsi.value.trim() : '';
      var num = parseInt(val);
      return !!state.brandsize || (!isNaN(num) && num >= 24 && num <= 40);
    }
    return true;
  }

  function goNext() {
    if (currentStep === 6) { applySize(); return; }
    if (!canProceed(currentStep)) return;
    if (currentStep === 4) {
      syncBrandSizeFromInput();
      goToStep(5);
      setTimeout(function () {
        state.result = calculateSize();
        goToStep(6);
        renderResult(state.result);
        var bn = btnNext();
        if (bn && state.result) {
          var sz  = state.result.displaySize;
          var ins = state.result.inseam ? ' / ' + state.result.inseam + '"' : '';
          bn.innerHTML = '\u2756 Got It \u2014 My Size is ' + sz + ins + ' \u203a';
          bn.classList.add('sa-btn-next--apply');
        }
        if (customerLogged && state.result) {
          saveProfile({ waist: state.result.waist, inseam: state.result.inseam, fit: state.fit });
        }
      }, 1700);
    } else {
      goToStep(currentStep + 1);
    }
  }

  function goBack() {
    if (currentStep > 1 && currentStep !== 5) goToStep(currentStep - 1);
  }

  function syncBrandSizeFromInput() {
    var bsi = $('sa-brandsize-input');
    if (!bsi) return;
    var val = bsi.value.trim();
    var num = parseInt(val);
    if (!isNaN(num) && num >= 24 && num <= 40 && !state.brandsize) {
      state.brandsize = String(num);
    }
  }

  /* ══════════════════════════════════════════════════
     STEP 4 — BRAND SIZE CHIPS
     ══════════════════════════════════════════════════ */

  function buildSizeChips(brand) {
    var container = $('sa-size-chips');
    if (!container) return;
    container.innerHTML = '';

    // Clear any previously selected chip state
    state.brandsize = null;
    state.usedChips = false;
    var bsi = $('sa-brandsize-input'); if (bsi) bsi.value = '';

    var sizes = brand ? BRAND_SIZES[brand] : null;
    var isNumeric = (!brand || sizes === null || sizes === undefined);
    var chipsData = isNumeric ? NUMERIC_SIZE_CHIPS : sizes;

    // Fix 2: prompt copy depends on brand + whether it's "other"
    var prompt = $('sa-brandsize-prompt');
    if (prompt) {
      if (!brand) {
        prompt.textContent = 'What size jeans do you usually wear?';
      } else if (brand === 'other') {
        prompt.textContent = 'What size jeans do you usually wear?';
      } else if (isNumeric) {
        prompt.textContent = 'What waist size do you wear in that brand?';
      } else {
        prompt.textContent = 'What size do you wear in that brand?';
      }
    }

    // Hide the manual waist input only for numeric-waist brands (chips already show inches)
    // Keep it visible for label-size brands (AE, Abercrombie, Old Navy) and no-brand default
    var waistRefWrap = $('sa-waist-ref-wrap');
    if (waistRefWrap) {
      // For numeric brands (Levi's, Wrangler etc.) chips ARE the inch sizes — hide manual input
      // For label brands or no brand — show manual input as fallback
      var brandUsesInchChips = brand && isNumeric && brand !== 'other' && brand !== '';
      if (brandUsesInchChips) {
        waistRefWrap.setAttribute('hidden', '');
      } else {
        waistRefWrap.removeAttribute('hidden');
      }
    }

    chipsData.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sa-chip sa-size-chip';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.dataset.waist = String(item.waist);
      btn.textContent = item.label;

      btn.addEventListener('click', function () {
        container.querySelectorAll('.sa-size-chip').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        // Also clear "not sure" chip
        document.querySelectorAll('.sa-chip[data-group="brandsize"]').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        state.brandsize = btn.dataset.waist;
        state.usedChips = true; // Fix 3: chip selection = high trust
        var bsi2 = $('sa-brandsize-input'); if (bsi2) bsi2.value = '';
        var bn = btnNext(); if (bn) bn.disabled = !canProceed(currentStep);
      });

      container.appendChild(btn);
    });
  }

  /* ══════════════════════════════════════════════════
     HEIGHT  (half-step support)
     ══════════════════════════════════════════════════ */

  function formatHeight(cm, unit) {
    if (unit === 'cm') {
      // Show one decimal only when it's a half value
      return cm % 1 === 0 ? String(cm) : cm.toFixed(1);
    } else {
      var totalInches = cm / 2.54;
      var feet   = Math.floor(totalInches / 12);
      var inches = totalInches % 12;
      // Round to nearest 0.5"
      var inchesRounded = Math.round(inches * 2) / 2;
      if (inchesRounded === 12) { feet += 1; inchesRounded = 0; }
      var inchStr = inchesRounded % 1 === 0
        ? String(inchesRounded)
        : inchesRounded.toFixed(1);
      return feet + "'" + inchStr + '"';
    }
  }

  function updateHeight(val) {
    state.height_cm = parseFloat(val);
    var disp = $('sa-height-display');
    if (disp) disp.textContent = formatHeight(state.height_cm, state.height_unit);
  }

  function switchHeightUnit(unit) {
    state.height_unit = unit;
    toggleClass('sa-h-cm', 'is-active', unit === 'cm');
    toggleClass('sa-h-in', 'is-active', unit !== 'cm');
    var slider = $('sa-height-slider');
    if (!slider) return;
    if (unit === 'cm') {
      slider.min = 140; slider.max = 195; slider.step = 0.5;
      slider.value = state.height_cm;
      safeSetText('sa-h-min', '140 cm'); safeSetText('sa-h-max', '195 cm');
      safeSetText('sa-height-unit', 'cm');
      var disp = $('sa-height-display');
      if (disp) disp.textContent = formatHeight(state.height_cm, 'cm');
      slider.oninput = function () { state.height_cm = parseFloat(this.value); updateHeight(this.value); updateSliderGradient(this); };
    } else {
      // Slider in half-inch steps
      var totalHalfIn = Math.round((state.height_cm / 2.54) * 2); // half-inches
      slider.min = 110; slider.max = 154; slider.step = 1; // half-inch steps: 110=55in=4'7", 154=77in=6'5"
      slider.value = totalHalfIn;
      safeSetText('sa-h-min', "4'7\""); safeSetText('sa-h-max', "6'5\"");
      safeSetText('sa-height-unit', '');
      var disp2 = $('sa-height-display');
      if (disp2) disp2.textContent = formatHeight(state.height_cm, 'in');
      slider.oninput = function () {
        var halfIn = parseInt(this.value);
        state.height_cm = Math.round((halfIn / 2) * 2.54 * 10) / 10;
        var d = $('sa-height-display');
        if (d) d.textContent = formatHeight(state.height_cm, 'in');
        updateSliderGradient(this);
      };
    }
    updateSliderGradient(slider);
  }

  /* ══════════════════════════════════════════════════
     WEIGHT
     ══════════════════════════════════════════════════ */

  function updateWeight(val) {
    state.weight_kg = parseInt(val);
    var disp = $('sa-weight-display');
    if (!disp) return;
    disp.textContent = state.weight_unit === 'kg' ? state.weight_kg : Math.round(state.weight_kg * 2.205);
  }

  function switchWeightUnit(unit) {
    state.weight_unit = unit;
    toggleClass('sa-w-kg', 'is-active', unit === 'kg');
    toggleClass('sa-w-lbs', 'is-active', unit !== 'kg');
    var slider = $('sa-weight-slider');
    if (!slider) return;
    if (unit === 'kg') {
      slider.min = 40; slider.max = 130; slider.step = 1; slider.value = state.weight_kg;
      safeSetText('sa-w-min', '40 kg'); safeSetText('sa-w-max', '130 kg');
      safeSetText('sa-weight-unit', 'kg'); safeSetText('sa-weight-display', state.weight_kg);
      slider.oninput = function () { state.weight_kg = parseInt(this.value); updateWeight(this.value); updateSliderGradient(this); };
    } else {
      var lbs = Math.round(state.weight_kg * 2.205);
      slider.min = 88; slider.max = 286; slider.step = 1; slider.value = lbs;
      safeSetText('sa-w-min', '88 lbs'); safeSetText('sa-w-max', '286 lbs');
      safeSetText('sa-weight-unit', 'lbs'); safeSetText('sa-weight-display', lbs);
      slider.oninput = function () {
        var lb = parseInt(this.value);
        state.weight_kg = Math.round(lb / 2.205);
        safeSetText('sa-weight-display', lb);
        updateSliderGradient(this);
      };
    }
    updateSliderGradient(slider);
  }

  function updateSliderGradient(slider) {
    var pct = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
    slider.style.backgroundSize = pct + '% 100%';
  }

  /* ══════════════════════════════════════════════════
     SELECTION HELPERS
     ══════════════════════════════════════════════════ */

  function selectOption(el, group) {
    document.querySelectorAll('.sa-option-card[data-group="' + group + '"]').forEach(function (c) {
      c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false');
    });
    el.classList.add('is-selected'); el.setAttribute('aria-checked', 'true');
    state[group] = el.dataset.val;
    var bn = btnNext(); if (bn) bn.disabled = !canProceed(currentStep);
  }

  function selectChip(el, group) {
    document.querySelectorAll('.sa-chip[data-group="' + group + '"]').forEach(function (c) {
      c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false');
    });
    // Also clear size chips
    document.querySelectorAll('.sa-size-chip').forEach(function (c) {
      c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false');
    });
    el.classList.add('is-selected'); el.setAttribute('aria-checked', 'true');
    state[group] = el.dataset.val;
    var bn = btnNext(); if (bn) bn.disabled = !canProceed(currentStep);
  }

  /* ══════════════════════════════════════════════════
     CALCULATION
     ══════════════════════════════════════════════════ */

  function calculateSize() {
    var h = state.height_cm;
    var w = state.weight_kg;
    var fit = state.fit;
    var brandsize  = state.brandsize;
    var brandbrand = state.brandbrand || 'other';

    var hm  = h / 100;
    var bmi = w / (hm * hm);

    var waistIn = (h * 0.165) + (w * 0.11) - 6;
    if (waistIn < 24) waistIn = 24;
    if (waistIn > 34) waistIn = 34;

    function waistToSize(w) {
      if (w < 25.5) return 24;
      if (w < 26.5) return 25;
      if (w < 27.5) return 26;
      if (w < 28.5) return 27;
      if (w < 29.5) return 28;
      if (w < 30.5) return 29;
      if (w < 31.5) return 30;
      if (w < 32.5) return 31;
      return 32;
    }

    var sizeFromMeasurements = waistToSize(waistIn);

    var finalSize;
    var userBrandSize;

    if (brandsize && brandsize !== 'not-sure') {
      userBrandSize = parseInt(brandsize);
      var offset = BRAND_OFFSETS[brandbrand] !== undefined ? BRAND_OFFSETS[brandbrand] : 0;
      var sizeFromBrand = userBrandSize + offset;
      // Fix 3: dynamic trust — chip selection is more reliable than manual typing
      var blendWeight = state.usedChips ? 0.92 : 0.85;
      var blended = sizeFromBrand * blendWeight + sizeFromMeasurements * (1 - blendWeight);
      if (Math.abs(blended - sizeFromBrand) > 1) {
        blended = sizeFromBrand + (blended > sizeFromBrand ? 1 : -1);
      }
      finalSize = clamp(Math.round(blended), 24, 34);
    } else {
      finalSize = clamp(sizeFromMeasurements, 24, 34);
    }

    if (fit === 'snug')    finalSize = Math.max(24, finalSize - 1);
    else if (fit === 'relaxed') finalSize = Math.min(34, finalSize + 1);

    // Trust lock — max ±1 jump from base
    var baseSize = brandsize && brandsize !== 'not-sure'
      ? clamp(userBrandSize, 24, 34)
      : clamp(sizeFromMeasurements, 24, 34);

    if (Math.abs(finalSize - baseSize) > 1) {
      finalSize = baseSize + (finalSize > baseSize ? 1 : -1);
    }
    finalSize = clamp(finalSize, 24, 34);

    // Inseam
    var availInseams = [];
    document.querySelectorAll('.option-selector').forEach(function (block) {
      var leg = block.querySelector('legend, .label');
      if (leg && leg.textContent.trim().toLowerCase() === 'inseam') {
        block.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          var v = (inp.value || '').replace(/[^0-9]/g, '').trim();
          if (v && availInseams.indexOf(v) === -1) availInseams.push(v);
        });
      }
    });

    var inseam = null;
    if (availInseams.length > 0) {
      if      (h <= 158) inseam = '30';
      else if (h <= 170) inseam = '32';
      else               inseam = '34';
      if (availInseams.indexOf(inseam) === -1) {
        inseam = availInseams.indexOf('32') > -1 ? '32' :
                 availInseams.indexOf('34') > -1 ? '34' :
                 availInseams.indexOf('30') > -1 ? '30' : availInseams[0];
      }
    }

    // Jacket detection
    var isJacket = false, jacketSize = null;
    document.querySelectorAll('.option-selector').forEach(function (block) {
      var leg = block.querySelector('legend, .label');
      if (leg && leg.textContent.trim().toLowerCase() === 'size') {
        block.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          var v = (inp.value || '').trim().toUpperCase();
          if (['XS','S','M','L','XL','XXL'].indexOf(v) > -1) isJacket = true;
        });
      }
    });
    if (isJacket) {
      if      (finalSize <= 25) jacketSize = 'XS';
      else if (finalSize <= 27) jacketSize = 'S';
      else if (finalSize <= 29) jacketSize = 'M';
      else if (finalSize <= 31) jacketSize = 'L';
      else if (finalSize <= 33) jacketSize = 'XL';
      else                      jacketSize = 'XXL';
    }

    // Confidence
    var conf = 82;
    if (brandsize && brandsize !== 'not-sure') {
      var diff = Math.abs(parseInt(brandsize) + (BRAND_OFFSETS[brandbrand] || 0) - finalSize);
      conf = diff === 0 ? 96 : diff === 1 ? 91 : diff === 2 ? 84 : 74;
    }

    var altSize = clamp(
      fit === 'snug' ? finalSize + 1 : finalSize - 1,
      24, 34
    );

    var suggestCurvy = bmi > 30;
    var isShorts = window.location.pathname.toLowerCase().includes('short');
    if (isShorts) inseam = null;

    return {
      waist:        finalSize,
      displaySize:  isJacket ? jacketSize : String(finalSize),
      isJacket:     isJacket,
      inseam:       inseam,
      confidence:   conf,
      altSize:      altSize,
      suggestCurvy: suggestCurvy,
      fit:          fit,
      inseamReason: inseam ? inseamReason(h, inseam) : null
    };
  }

  function inseamReason(h, inseam) {
    if (inseam === '30') return '30\u2033 inseam \u2014 ideal for your height';
    if (inseam === '32') return '32\u2033 inseam \u2014 perfect for your height';
    return '34\u2033 inseam \u2014 full length for your height';
  }

  /* ══════════════════════════════════════════════════
     RENDER RESULT
     ══════════════════════════════════════════════════ */

  function renderResult(r) {
    var resWaist = $('sa-res-waist');
    if (resWaist) {
      resWaist.innerHTML = r.isJacket
        ? r.displaySize + ' <span>size</span>'
        : r.waist + ' <span>waist</span>';
    }

    var inseamEl = $('sa-res-inseam');
    if (inseamEl) {
      if (r.inseam && r.inseamReason) {
        inseamEl.textContent = r.inseamReason;
        inseamEl.style.display = '';
      } else {
        inseamEl.textContent = ''; inseamEl.style.display = 'none';
      }
    }

    safeSetText('sa-conf-pct', r.confidence + '%');
    setTimeout(function () {
      var cf = $('sa-conf-fill');
      if (cf) { cf.style.width = r.confidence + '%'; cf.parentElement.setAttribute('aria-valuenow', r.confidence); }
    }, 80);

    var confLabel = r.confidence >= 90 ? 'High' : r.confidence >= 80 ? 'Medium' : 'Low';
    safeSetText('sa-conf-level', confLabel);

    var tagsEl = $('sa-fit-tags');
    if (tagsEl) {
      var tags = [];
      var fitLabels = { snug: 'Snug fit', regular: 'True to size', relaxed: 'Relaxed fit' };
      var fitColor  = { snug: 'green', regular: 'green', relaxed: 'amber' };
      if (r.fit && fitLabels[r.fit]) tags.push({ t: fitLabels[r.fit], c: fitColor[r.fit] });
      if (r.inseam) tags.push({ t: 'Inseam ' + r.inseam + '"', c: 'green' });
      if (r.isJacket) tags.push({ t: 'Jacket ' + r.displaySize, c: 'green' });
      tagsEl.innerHTML = tags.map(function (tag) {
        return '<span class="sa-fit-tag sa-fit-tag--' + tag.c + '">' + escapeHtml(tag.t) + '</span>';
      }).join('');
    }

    var tipEl = $('sa-result-tip');
    if (tipEl) tipEl.innerHTML = buildTip(r);

    var altEl = $('sa-alt-size');
    if (altEl) {
      if (!r.isJacket && r.altSize !== r.waist) {
        var direction = r.altSize > r.waist ? 'looser' : 'snugger';
        altEl.innerHTML = 'Between sizes? Also try <strong>' + r.altSize + '</strong> for a ' + direction + ' feel.';
      } else {
        altEl.innerHTML = '';
      }
    }

    var curvyEl = $('sa-curvy-note');
    if (curvyEl) {
      if (r.suggestCurvy && !r.isJacket) {
        var curvyUrl = window.SizeAdvisorConfig ? window.SizeAdvisorConfig.curvyCollectionUrl : '/collections/curvy-jeans';
        curvyEl.innerHTML = '\u2756 Your measurements suggest our <a href="' + curvyUrl + '">Curvy Collection</a> may fit you even better \u2014 designed for fuller waists and curvier hips.';
        curvyEl.removeAttribute('hidden');
      } else {
        curvyEl.setAttribute('hidden', '');
      }
    }
  }

  function buildTip(r) {
    if (r.isJacket) return '<strong>Jacket size ' + r.displaySize + ':</strong> Based on your measurements and fit preference.';
    if (r.fit === 'snug')    return '<strong>Snug fit:</strong> Sized slightly down for a close, body-hugging feel.';
    if (r.fit === 'relaxed') return '<strong>Relaxed fit:</strong> Sized slightly up for a more comfortable, easy fit.';
    return '<strong>True to size:</strong> This matches your measurements to our standard fit.';
  }

  /* ══════════════════════════════════════════════════
     APPLY SIZE
     ══════════════════════════════════════════════════ */

  function applySize() {
    var r = state.result;
    if (!r) return;
    saveProfile({ waist: r.waist, inseam: r.inseam, fit: state.fit });
    closeModal();
    setTimeout(function () {
      var sp = document.querySelector('.size-advisor-trigger span');
      if (sp) {
        var sz  = r.displaySize;
        var ins = r.inseam ? ' / ' + r.inseam + '"' : '';
        sp.textContent = '\u2756 Your Size: ' + sz + ins;
      }
      var trigBtn = document.querySelector('.size-advisor-trigger');
      if (trigBtn) trigBtn.style.color = '#111111';
      loadSavedProfile();
    }, 300);
  }

  function isWaistOption(val) {
    var n = parseInt(val); return n >= 24 && n <= 36;
  }

  function loadSavedProfile() {
    loadProfile(function (saved) {
      if (!saved || !saved.waist) return;
      var triggerSpan = document.querySelector('.size-advisor-trigger span');
      if (triggerSpan && saved.waist) {
        var lbl = '\u2756 Your Size: ' + saved.waist;
        if (saved.inseam) lbl += ' / ' + saved.inseam + '"';
        triggerSpan.textContent = lbl;
      }
      document.querySelectorAll('.option-selector input[type="radio"]').forEach(function (input) {
        var val  = (input.value || '').trim();
        var name = (input.name || '').toLowerCase();
        if (val === String(saved.waist) && isWaistOption(val)) {
          var lbl2 = input.nextElementSibling || document.querySelector('label[for="' + input.id + '"]');
          if (lbl2) lbl2.classList.add('sa-rec-highlight');
        }
        if (saved.inseam && val === saved.inseam && /inseam/i.test(name)) {
          var lbl3 = input.nextElementSibling || document.querySelector('label[for="' + input.id + '"]');
          if (lbl3) lbl3.classList.add('sa-rec-highlight');
        }
      });
    });
  }

  /* ══════════════════════════════════════════════════
     EVENT BINDING
     ══════════════════════════════════════════════════ */

  function bindEvents() {
    var m = modal();
    if (!m) return;

    m.querySelectorAll('[data-size-advisor-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && m.classList.contains('is-open')) closeModal();
    });

    var bb = btnBack(); if (bb) bb.addEventListener('click', goBack);
    var bn = btnNext(); if (bn) bn.addEventListener('click', goNext);

    // Height slider — half-step
    var hs = $('sa-height-slider');
    if (hs) hs.addEventListener('input', function () {
      state.height_cm = parseFloat(this.value);
      updateHeight(this.value);
      updateSliderGradient(this);
    });

    var ws = $('sa-weight-slider');
    if (ws) ws.addEventListener('input', function () { updateWeight(this.value); updateSliderGradient(this); });

    var hCm  = $('sa-h-cm');  if (hCm)  hCm.addEventListener('click',  function () { switchHeightUnit('cm'); });
    var hIn  = $('sa-h-in');  if (hIn)  hIn.addEventListener('click',  function () { switchHeightUnit('in'); });
    var wKg  = $('sa-w-kg');  if (wKg)  wKg.addEventListener('click',  function () { switchWeightUnit('kg'); });
    var wLbs = $('sa-w-lbs'); if (wLbs) wLbs.addEventListener('click', function () { switchWeightUnit('lbs'); });

    m.querySelectorAll('.sa-option-card').forEach(function (card) {
      card.addEventListener('click', function () { selectOption(this, this.dataset.group); });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectOption(card, card.dataset.group); }
      });
    });

    // Step 4: brand dropdown refines size chips (Fix 1: chips always visible)
    var bdd = $('sa-brand-dropdown');
    if (bdd) {
      bdd.addEventListener('change', function () {
        var brand = this.value;
        state.brandbrand = brand || null;

        // Always rebuild chips — if no brand selected, show default numeric chips (Fix 1)
        buildSizeChips(brand);

        // Clear not-sure selection if brand chosen
        document.querySelectorAll('.sa-chip[data-group="brandsize"]').forEach(function (c) {
          c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false');
        });
        if (state.brandsize === 'not-sure') state.brandsize = null;
        var bn2 = btnNext(); if (bn2) bn2.disabled = !canProceed(currentStep);
      });
    }

    // Manual waist inch input (secondary input on Step 4)
    var bsi = $('sa-brandsize-input');
    if (bsi) {
      bsi.addEventListener('input', function () {
        var val = parseInt(this.value.trim());
        if (!isNaN(val) && val >= 24 && val <= 40) {
          // Fix 5: always override — manual input takes precedence over any chip selection
          state.brandsize = String(val);
          state.usedChips = false; // typed = lower trust (Fix 3)
          // Clear chip selections
          document.querySelectorAll('.sa-size-chip').forEach(function (c) {
            c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false');
          });
          document.querySelectorAll('.sa-chip[data-group="brandsize"]').forEach(function (c) {
            c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false');
          });
        } else {
          state.brandsize = null;
          state.usedChips = false;
        }
        var bn2 = btnNext(); if (bn2) bn2.disabled = !canProceed(currentStep);
      });
    }

    // "Not sure" chip
    m.querySelectorAll('.sa-chip[data-group="brandsize"]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        selectChip(this, 'brandsize');
        var bsi2 = $('sa-brandsize-input'); if (bsi2) bsi2.value = '';
      });
    });

    if (hs) updateSliderGradient(hs);
    if (ws) updateSliderGradient(ws);
  }

  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-size-advisor-open]');
      if (trigger) { e.preventDefault(); openModal(); }
    });
  }

  /* ── UTILS ── */
  function clamp(val, min, max) { return Math.max(min, Math.min(max, val)); }
  function safeSetText(id, text) { var el = $(id); if (el) el.textContent = String(text); }
  function toggleClass(id, cls, condition) { var el = $(id); if (el) el.classList.toggle(cls, condition); }
  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── INIT ── */
  function init() {
    detectCustomer();
    bindEvents();
    bindTriggers();
    loadSavedProfile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SizeAdvisor = { open: openModal, close: closeModal, reset: resetAdvisor };

})();
